import { MetadataService } from '@wix/cashier-core/dist/src/services/Metadata';
import React from 'react';
import { DH } from '../../../../utils/DataHook';
import { DropdownField } from '../DropdownField';
import { DropdownFieldAPI } from '../DropdownField/types';
import { BaseFieldProps } from '../types';
import { patchMetadataServiceBaseURL } from '../utils';

interface StateDropdownProps extends BaseFieldProps {
  host?: string;
  countryCode?: string;
}

export class StateDropdown extends React.Component<StateDropdownProps> {
  dropdownApi: DropdownFieldAPI;

  fetchStateItems = () => {
    return new MetadataService({
      baseURL: patchMetadataServiceBaseURL(this.props.host),
    }).fetchStates(this.props.locale, this.props.countryCode);
  };

  componentDidUpdate(prevProps: StateDropdownProps) {
    if (this.props.countryCode !== prevProps.countryCode) {
      this.dropdownApi.reloadItems();
    }
  }

  render() {
    return (
      <div data-hook={DH.PaymentDetails.StateDropdown}>
        <DropdownField
          {...this.props}
          fetchItems={this.fetchStateItems}
          withInputFallback
          onApiInit={(api) => (this.dropdownApi = api)}
        />
      </div>
    );
  }
}
